import { useEffect } from "react";
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const PieChart = ({ data }) => {
   
    const GHG = [];
    const water = [];
    const waste = [];
    const energy = [];

    data.values.forEach((val) => {
        GHG.push((val.emission_per))
        water.push((val.water_per))
        waste.push((val.waste_per))
        energy.push((val.energy_per))

    });


    useEffect(() => {

        const createPieChart = (chartId, labels, data, backgroundColor, borderColor, chartName) => {

            const existingChart = Chart.getChart(chartId);

            if (existingChart) {
                existingChart.destroy();
            }

            const pieChartDataset = {
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderWidth: 2
                }]
            };

            const pieChartOptions = {
                responsive: true,
                aspectRatio: 2,
                plugins: {
                    legend: {
                        position: 'right',
                        labels: {
                            boxWidth: 20,
                            padding: 10,
                        }
                    },
                    datalabels: {
                        formatter: (value, context) => {
                            const dataset = context.chart.data.datasets[context.datasetIndex];
                            const total = dataset.data.reduce((previousValue, currentValue) => previousValue + currentValue);
                            const percentage = ((value / total) * 100).toFixed(2) + '%';
                            return percentage;
                        },
                        color: 'black',
                        display: 'auto',
                        font: {
                            weight: 'bold',
                            size: 9, 
                        },
                        anchor: 'center',
                    }
                },
            };

            const pieChartCtx = document.getElementById(chartId).getContext('2d');
            new Chart(pieChartCtx, {
                type: 'pie',
                data: pieChartDataset,
                options: pieChartOptions,
                plugins: [ChartDataLabels],
            });

            const chartNameElement = document.createElement('div');
            chartNameElement.innerText = chartName;
            chartNameElement.className = 'chart-name';
            const existingChartNameElement = document.querySelector(`#${chartId} ~ .chart-name`);
            if (!existingChartNameElement) {
                document.getElementById(chartId).parentNode.appendChild(chartNameElement);
            }

        };

        // Create four pie charts in the same row
        createPieChart('pieChart1', ['2020', '2021', '2022'], GHG, ['rgb(67, 160, 71)', 'rgb(123, 189, 126)', 'rgb(180, 217, 181)'], 'white', "Total GHG Emission(mtCo2)");
        createPieChart('pieChart2', ['2020', '2021', '2022'], water, ['rgb(0, 114, 240)', 'rgb(77, 156, 245)', 'rgb(153, 199, 249)'], 'white', "Total Water Withdrawl(Gallons)");
        createPieChart('pieChart3', ['2020', '2021', '2022'], waste, ['rgb(183, 28, 28)', 'rgb(205, 96, 96)', 'rgb(226, 164, 164)'], 'white', "Total Hazardous Waste(Metric Ton)");
        createPieChart('pieChart4', ['2020', '2021', '2022'], energy, ['rgb(255, 193, 7)', 'rgb(255, 212, 81)', 'rgb(255, 230, 156)'], 'white', "Total Energy Consumed(KWh)");
    }, [data]);

    return (
        <>
            <div className="col-md-3">
                <canvas id="pieChart1" className="chart"></canvas>
            </div>
            <div className="col-md-3">
                <canvas id="pieChart2" className="chart"></canvas>
            </div>
            <div className="col-md-3">
                <canvas id="pieChart3" className="chart"></canvas>
            </div>
            <div className="col-md-3">
                <canvas id="pieChart4" className="chart"></canvas>
            </div>
        </>
    );
}

export default PieChart